import type { OpportunityCandidate } from '@axiom/validation';

export const CandidateRateUtil = {
  hasSubmittedRate: (opportunityCandidate?: OpportunityCandidate) => {
    return !!opportunityCandidate?.displayBillingRate;
  },
  isWithinMargin: (opportunityCandidate?: OpportunityCandidate) => {
    const marginApprovalFloor = opportunityCandidate?.marginApprovalFloor;
    const proposedMarginTarget = opportunityCandidate?.proposedMarginTarget;

    return (
      !!marginApprovalFloor &&
      !!proposedMarginTarget &&
      proposedMarginTarget >= marginApprovalFloor
    );
  },
  isOverMargin: (opportunityCandidate?: OpportunityCandidate) => {
    const marginApprovalCeiling = opportunityCandidate?.marginApprovalCeiling;

    const proposedMarginTarget = opportunityCandidate?.proposedMarginTarget;

    return (
      !!marginApprovalCeiling &&
      !!proposedMarginTarget &&
      proposedMarginTarget > marginApprovalCeiling
    );
  },
};
